export default __webpack_public_path__ + "static/media/leftArrowLogo.314405a3.svg";